/* Comportements de scroll partagés — nés sur les pages implantation,
   génériques par attribut : toute section qui pose [data-mm-parallax] ou
   [data-mm-reveal] et charge ce fichier en profite (MM-Implantation-Hero,
   MM-Implantation-Intro, MM-Expertise-Intro). Le nom du fichier suit
   l'histoire, pas le périmètre.
   Deux effets, tous deux inertes en prefers-reduced-motion :

   1. PARALLAX DU HERO ([data-mm-parallax]). L'image fait 120 % de la
      hauteur de son cadre (CSS), posée à -10 % : 10 % de course de chaque
      côté. Le transform suit la position du hero dans le viewport, jamais
      le scroll brut — la valeur est bornée, l'image ne découvre jamais le
      fond. Lecture au scroll, écriture dans un rAF : une seule écriture
      par frame, pas de layout thrashing. Lenis scrolle nativement, les
      événements scroll arrivent normalement.

   2. RÉVÉLATION DE L'INTRO ([data-mm-reveal]). Les paragraphes sont
      découpés en mots insécables (<span class="mm-impl-w">) faits de
      lettres (<span class="mm-impl-l">) ; chaque lettre porte --r qui monte
      de 0 à 1 selon la progression du bloc dans le viewport, le CSS traduit
      en opacité 40 % → 100 %. Le front passe donc au milieu d'un mot, comme
      sur la maquette. Le découpage préserve les balises internes (strong,
      em, liens) en ne touchant que les nœuds texte, et ne crée pas de point
      de coupe : sans espace entre les spans, un mot reste un mot.

      Le front est LISSÉ : la position tirée du scroll est une cible, et une
      boucle rAF fait glisser le front vers elle par interpolation (mêmes
      réglages que la jauge de lecture du blog, facteur 0.12 par frame) — à
      la molette, dont le scroll avance par crans, le front coule au lieu de
      sauter. La boucle ne tourne que le temps de converger : posée à moins
      d'un vingtième de lettre de la cible, elle s'endort, et les événements
      scroll/resize la réveillent — un réveil qui ne change rien se rendort
      sans toucher aux lettres, et un bloc hors écran (garde
      IntersectionObserver, comme le parallax) ne se réveille pas du tout.
      Réveils aussi sur fonts.ready et load : la géométrie bouge sans
      scroll quand la police arrive ou qu'une image tardive pousse la page.
      Dans l'éditeur de thème, l'état est peint d'emblée (pas d'entrée
      rejouée à chaque réglage touché) et une closure dont le bloc a été
      remplacé se démonte au premier réveil. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Parallax ---------- */
  function initParallax(hero) {
    /* La classe implantation d'abord (l'aînée), sinon la première image du
       bloc : tout hero qui pose [data-mm-parallax] et dimensionne son image
       à 120 % / -10 % en CSS profite du même mouvement. */
    var img = hero.querySelector('.mm-impl-hero__img') || hero.querySelector('img');
    if (!img) return;

    var ticking = false;
    var visible = true;
    var io = null;

    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      /* Progression du hero dans le viewport : 0 quand son haut touche le
         haut de l'écran (chargement), 1 quand il en est complètement
         sorti. En haut de page, r.top vaut 0 → aucun décalage au repos. */
      var p = Math.min(1, Math.max(0, -r.top / r.height));
      /* Course : 10 % de la hauteur de l'image (elle en a 20 en réserve). */
      img.style.transform = 'translate3d(0, ' + (p * 10).toFixed(3) + '%, 0)';
    }

    function onScroll() {
      /* Hero remplacé par l'éditeur de thème : la closure se démonte,
         le ramasse-miettes récupère l'arbre détaché. */
      if (!hero.isConnected) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (io) io.disconnect();
        return;
      }
      if (!visible || ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      });
      io.observe(hero);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- Révélation lettre à lettre ---------- */
  function splitLetters(root) {
    var letters = [];
    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var parts = node.textContent.split(/(\s+)/);
        if (parts.length < 2 && !parts[0].trim()) return;
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            var w = document.createElement('span');
            w.className = 'mm-impl-w';
            for (var i = 0; i < part.length; i++) {
              var l = document.createElement('span');
              l.className = 'mm-impl-l';
              l.textContent = part.charAt(i);
              w.appendChild(l);
              letters.push(l);
            }
            frag.appendChild(w);
          }
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.prototype.slice.call(node.childNodes).forEach(walk);
      }
    }
    walk(root);
    return letters;
  }

  function initReveal(block) {
    var letters = splitLetters(block);
    if (!letters.length) return;

    /* Front en unités de lettres : `cible` suit le scroll, `courant` glisse
       vers elle. `valeurs` retient la dernière valeur écrite par lettre pour
       ne toucher le style que des lettres dont la valeur change — en régime
       posé, la boucle ne réécrit rien. */
    var cible = 0;
    var courant = 0;
    var valeurs = new Array(letters.length);
    var enVol = false;
    var visible = true;
    var io = null;

    function mesurer() {
      var r = block.getBoundingClientRect();
      /* Un bloc masqué ou détaché rend un rect nul : sans ce retour, la
         division tombait sur le garde-fou de 1px et p débordait vers 1 —
         l'état « caché » se lisait « entièrement révélé », et le bloc
         redevenu visible se DÉ-révélait sous les yeux. On garde la
         dernière cible saine. */
      if (!r.height) return;
      var vh = window.innerHeight || 1;
      /* Ligne de lecture aux deux tiers de l'écran : la progression vaut 0
         quand le haut du bloc l'atteint, 1 quand le bas la dépasse. */
      var line = vh * 0.66;
      var p = (line - r.top) / r.height;
      p = Math.min(1, Math.max(0, p));
      cible = p * letters.length;
    }

    function peindre() {
      for (var i = 0; i < letters.length; i++) {
        /* Fenêtre de 4 lettres autour du front : assez de dégradé pour ne
           pas hacher, assez court pour que la coupe se lise dans le mot. */
        var v = Math.min(1, Math.max(0, (courant - i) / 4 + 1));
        /* Arrondi en NOMBRE : comparer des chaînes toFixed allouait des
           centaines de chaînes par frame de vol pour rien ; setProperty
           convertit tout seul à l'écriture, qui est rare. */
        v = Math.round(v * 1000) / 1000;
        if (valeurs[i] !== v) {
          valeurs[i] = v;
          letters[i].style.setProperty('--r', v);
        }
      }
    }

    /* L'éditeur de thème remplace le DOM d'une section sans décharger la
       page : la closure de l'ancien bloc survivrait, branchée sur window,
       et retiendrait tout son arbre de lettres. Un bloc débranché démonte
       tout — les écouteurs partent, le ramasse-miettes fait le reste. */
    function demonter() {
      window.removeEventListener('scroll', reveiller);
      window.removeEventListener('resize', reveiller);
      if (io) io.disconnect();
    }

    function boucle() {
      if (!block.isConnected) {
        enVol = false;
        demonter();
        return;
      }
      /* La cible se remesure à chaque frame : pendant une inertie de
         trackpad la position vraie bouge entre deux événements scroll. */
      mesurer();
      if (Math.abs(cible - courant) < 0.05) {
        /* Posé. Si le réveil n'a rien changé (cas de loin le plus fréquent :
           un scroll ailleurs dans la page), on se rendort sans repeindre —
           zéro itération de lettres en régime posé. */
        if (courant !== cible) {
          courant = cible;
          peindre();
        }
        enVol = false;
        return;
      }
      courant += (cible - courant) * 0.12;
      peindre();
      requestAnimationFrame(boucle);
    }

    function reveiller() {
      if (!block.isConnected) {
        demonter();
        return;
      }
      if (!visible || enVol) return;
      enVol = true;
      requestAnimationFrame(boucle);
    }

    /* Même garde de visibilité que le parallax : un bloc hors écran ne
       paie pas ses réveils. Le retour à l'écran repeint l'état vrai. */
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) reveiller();
      }, { rootMargin: '20% 0px' });
      io.observe(block);
    }

    window.addEventListener('scroll', reveiller, { passive: true });
    window.addEventListener('resize', reveiller, { passive: true });
    /* La géométrie bouge aussi sans scroll : swap de police (le bloc perd
       des lignes), images tardives plus haut dans la page. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { reveiller(); });
    }
    window.addEventListener('load', reveiller, { once: true });

    /* Premier passage : `courant` part de zéro, le front coule jusqu'à sa
       position — l'arrivée en milieu de page a droit à son entrée. Sauf
       dans l'éditeur de thème : chaque re-rendu de section repasse ici, et
       rejouer l'entrée ferait clignoter le paragraphe à chaque réglage
       touché — on peint l'état exact, comme avant le lissage. */
    if (window.Shopify && window.Shopify.designMode) {
      mesurer();
      courant = cible;
      peindre();
    }
    reveiller();
  }

  function init() {
    if (reduced.matches) return;
    /* Une garde PAR EFFET : avec une garde commune, un élément qui
       cumulerait les deux attributs serait servi par le premier scan et
       silencieusement exclu du second. */
    document.querySelectorAll('[data-mm-parallax]:not([data-mm-done-parallax])').forEach(function (el) {
      el.setAttribute('data-mm-done-parallax', '');
      initParallax(el);
    });
    document.querySelectorAll('[data-mm-reveal]:not([data-mm-done-reveal])').forEach(function (el) {
      el.setAttribute('data-mm-done-reveal', '');
      initReveal(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* L'éditeur de thème recharge les sections sans recharger la page. */
  document.addEventListener('shopify:section:load', init);
})();
